export enum AlertStatusType {
    Null = 0,
    Notification = 1,
    Interaction = 2,
    Workflow = 3,
    Activity = 4,
    ProblemState = 5,
    CaseUserStatus = 6,
    CaseAssignedToUser = 7,
    CaseAssignedToLocation = 8
}

export enum AlertStatusTypeString {
    Null = 'Null',
    Notification = 'Notification',
    Interaction = 'Interaction',
    Workflow = 'Workflow',
    Activity = 'Activity',
    ProblemState = 'Monitoring State',
    CaseUserStatus = 'Work Status',
    CaseAssignedToUser = 'Assigned User Status',
    CaseAssignedToLocation = 'Assigned Location Status'
}